import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { AuthContext } from "../AuthContext";
import { jwtDecode } from "jwt-decode";

// Función para extraer el ID del token
const getUserIdFromToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.id || decoded.user_id || decoded._id || null;
  } catch {
    return null;
  }
};

const formatDate = (date) => date.toISOString().split("T")[0];

const BitacoraHoy = () => {
  const { user } = useContext(AuthContext);
  const userId = user?.token ? getUserIdFromToken(user.token) : null;

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newEntry, setNewEntry] = useState({ titulo: "", texto: "" });

  const formattedDate = formatDate(selectedDate);

  const fetchEntries = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const res = await axios.get(`http://192.168.1.81:5000/backend/api/bitacoras/${userId}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      const allEntries = res.data || [];
      const filtered = allEntries.filter((entry) => entry.fecha?.split("T")[0] === formattedDate);
      setEntries(filtered);
    } catch (err) {
      console.error("Error al obtener entradas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, [selectedDate]);

  const handleNewEntryChange = (e) => {
    const { name, value } = e.target;
    setNewEntry((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddEntry = async (e) => {
    e.preventDefault();
    if (!newEntry.titulo || !newEntry.texto) {
      return alert("Todos los campos son obligatorios.");
    }

    try {
      const entryData = {
        ...newEntry,
        fecha: formattedDate,
        user_id: userId,
      };
      await axios.post("http://192.168.1.81:5000/backend/api/bitacoras", entryData, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      setNewEntry({ titulo: "", texto: "" });
      setShowModal(false);
      fetchEntries();
    } catch (err) {
      console.error("Error al agregar entrada:", err);
      alert("No se pudo agregar la entrada.");
    }
  };

  const goToNextDay = () => {
    setSelectedDate((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(newDate.getDate() + 1);
      return newDate;
    });
  };

  const goToPreviousDay = () => {
    setSelectedDate((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(newDate.getDate() - 1);
      return newDate;
    });
  };

  const getStartOfWeek = (date) => {
    const temp = new Date(date);
    const day = temp.getDay() === 0 ? -6 : 1 - temp.getDay(); // Lunes como inicio
    temp.setDate(temp.getDate() + day);
    return temp;
  };

  const weekDays = Array.from({ length: 7 }, (_, i) => {
  const day = new Date(getStartOfWeek(selectedDate));
  day.setDate(day.getDate() + i);

  // Obtener la inicial del día en español
  const weekdayMap = {
    lun: "L ",
    mar: "M ",
    mié: "M",
    jue: "J",
    vie: "V",
    sáb: "S",
    dom: "D",
  };

  const shortWeekday = day
    .toLocaleDateString("es-ES", { weekday: "short" })
    .toLowerCase();

  return {
    date: formatDate(day),
    label: `${weekdayMap[shortWeekday]} ${day.getDate()}`,
  };
});



  return (
    <div className="bitacora-section mt-4">
      
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Button style={{fontSize: "20px", borderRadius: "50%", margin: "10px 15px"}} variant="outline-dark" onClick={goToPreviousDay}>
          ← 
        </Button>
        <div className="d-flex justify-content-between mb-4" style={{ fontSize: "12px", flex: 0.1 }}>
        {weekDays.map((day) => {
          const isSelected = day.date === formatDate(selectedDate);
          return (
            <div
              key={day.date}
              className="text-center p-2 rounded"
              style={{
                backgroundColor: isSelected ? "#F28C28" : "#FFF3E0",
                color: isSelected ? "#fff" : "#000",
                cursor: "pointer",
                flex: 1,
              }}
              onClick={() => setSelectedDate(new Date(day.date))}
            >
              {day.label}
            </div>
          );
        })}
      </div>
        <Button style={{fontSize: "20px", borderRadius: "50%", margin: "10px 15px"}} variant="outline-dark" onClick={goToNextDay}>
           →
        </Button>
      </div>
      
       <h5 className="mb-0 text-center" style={{ color: "#F28C28" }}>
          {selectedDate.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" })}
        </h5>


      {loading ? (
        <div className="text-center"><Spinner animation="border" variant="warning" /></div>
      ) : (
        <div>
          {entries.length === 0 ? (
            <p className="text-muted">No hay registros para este día.</p>
          ) : (
            entries.map((entry) => (
              <div key={entry.id || entry._id} className="p-2 mb-2 border rounded" style={{ backgroundColor: "#FFF3E0" }}>
                <strong>{entry.titulo}</strong>
                <p className="mb-0">{entry.texto}</p>
              </div>
            ))
          )}
        </div>
      )}

      <Button variant="success" size="sm" className="mt-2" onClick={() => setShowModal(true)}>
        + Agregar Entrada
      </Button>

      {/* Modal para nueva entrada */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton style={{ backgroundColor: "#F28C28", color: "#fff" }}>
          <Modal.Title>Agregar Entrada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddEntry}>
            <input
              type="text"
              name="titulo"
              className="form-control mb-2"
              placeholder="Título"
              value={newEntry.titulo}
              onChange={handleNewEntryChange}
              required
            />
            <textarea
              name="texto"
              className="form-control mb-2"
              placeholder="Descripción"
              rows={3}
              value={newEntry.texto}
              onChange={handleNewEntryChange}
              required
            />
            <Button variant="dark" type="submit" className="w-100">
              Guardar Entrada
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BitacoraHoy;
